import { render } from "./NguoiDungTable.vue?vue&type=template&id=8818ff04&ts=true"
import script from "./NguoiDungTable.vue?vue&type=script&lang=ts"
export * from "./NguoiDungTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__